export default __webpack_public_path__ + "static/media/tubeTrailer.39f23289.svg";